// extracted by mini-css-extract-plugin
export default {"btn":"styles_btn__rHZkI","primary":"styles_primary__viLj2","tertiary":"styles_tertiary__6tT4+","alignment":"styles_alignment__CjXPw","capitalized":"styles_capitalized__ljm32"};